import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalContextService {
  private readonly _currentLocalId = new BehaviorSubject<number | null>(
    this.loadInitialLocal(),
  );

  public readonly currentLocalId$ = this._currentLocalId.asObservable();

  constructor() {}

  private loadInitialLocal(): number | null {
    const storedValue = localStorage.getItem('selectedLocalId');
    return storedValue ? Number(storedValue) : null;
  }

  public getCurrentLocalId(): number | null {
    return this._currentLocalId.getValue();
  }

  public setLocal(localId: number) {
    localStorage.setItem('selectedLocalId', localId.toString());
    this._currentLocalId.next(localId);
  }
}
